// Adapted from https://davidwalsh.name/javascript-debounce-function:

/** Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function `func` will be called after it stops being called for
 * `wait` milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. */
export default function debounce(func: Function, wait: number, immediate: boolean) {
	let timeout;
	return function() {
		const context = this, args = arguments;
		const later = () => {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};
